export type Platform = keyof typeof PlatformEnum;

export enum PlatformEnum {
  PC = 'pc',
  H5 = 'h5',
  MINI_PROGRAM = 'miniProgram',
  APP = 'app',
}
